export const isDevelopment = () => process.env.NODE_ENV === 'development';

export const newTabLink = (url: string) => {
  window.open(`${process.env.PUBLIC_URL}${url}`, '_blank');
};

export const loginRedirect = (target: string = '/badatelna') => {
  const url = isDevelopment()
    ? 'https://ais-ap1tst.is.cuni.cz'
    : window.location.origin;
  window.location.href = `${url}/Shibboleth.sso/Login?target=${target}`;
};
